/*
 * <contact-form> (sections/contact-form.liquid): inline validation for the contact form. Required
 * fields show their message under the field (aria-invalid + aria-describedby) and focus moves to the
 * first problem. After a submit, focus moves to the success panel or the server's error summary.
 */
if (!customElements.get('contact-form')) {
  customElements.define(
    'contact-form',
    class ContactForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        const landing = this.querySelector('[data-contact-success], [data-contact-errors]');
        if (landing) {
          requestAnimationFrame(() => {
            landing.focus({ preventScroll: true });
            landing.scrollIntoView({ block: 'center' });
          });
        }
        if (!this.form) return;

        this.fields = Array.from(this.form.querySelectorAll('[required]'));
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.fields.forEach((field) => {
          field.addEventListener('input', () => {
            if (field.getAttribute('aria-invalid') === 'true') this.validate(field);
          });
          field.addEventListener('blur', () => {
            if (field.value.trim() !== '') this.validate(field);
          });
        });
      }

      validate(field) {
        const value = field.value.trim();
        let message = '';
        if (value === '') {
          message = field.dataset.errorRequired || '';
        } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          message = field.dataset.errorFormat || field.dataset.errorRequired || '';
        }
        const error = document.getElementById(`${field.id}-error`);
        if (error) error.textContent = message;
        if (message) {
          field.setAttribute('aria-invalid', 'true');
        } else {
          field.removeAttribute('aria-invalid');
        }
        return !message;
      }

      onSubmit(event) {
        const invalid = this.fields.filter((field) => !this.validate(field));
        if (!invalid.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        invalid[0].focus();
      }
    }
  );
}
